var myLazyLoad = new LazyLoad({
    elements_selector: ".lazy",
});

$(function () {
    var mobile = false;
    var tablet = false;
    var desktop = false;

    gsap.config({ nullTargetWarn: false });
    function selectPoints() {
        document.cookie = "priceViewOption=points";
    }
    const pointsProducts = document.querySelectorAll("#HP_points a, #HP_points_mb a");
    
    pointsProducts.forEach(function(element){
        element.addEventListener("click", selectPoints);
        element.addEventListener("mousedown", selectPoints);
    })
    function checkWidth() {
        var viewportWidth = window.viewportSize.getWidth();
        if (viewportWidth <= 768) {
            if (!mobile) {
                $("body").addClass("mobile").removeClass("desktop");
                $("body.pgproduct .cart-handler h1").insertAfter("ol.breadcrumb");
                $("body.pgproduct ul.slides li a").contents().unwrap();
                $(".header nav").insertAfter(".header .header-inner");
            }
            mobile = true;
            desktop = false;
            tablet = false;
        } else if (viewportWidth >= 769 && viewportWidth <= 960) {
            if (!tablet) {
                $("body").removeClass("mobile desktop").addClass("tablet");
                $(".header nav").insertAfter(".header .header-inner");
            }
            mobile = false;
            desktop = false;
            tablet = true;
        } else {
            if (!desktop) {
                $("body").removeClass("mobile").addClass("desktop");
                $(".header nav").insertAfter(".header-inner .utilities");
            }
            mobile = false;
            desktop = true;
            tablet = false;
        }
    }
    checkWidth();
    $(window).on("resize", checkWidth);

    /* Menus*/

    $(function () {
        function toggleSites() {
            $(".global-sites div .menu-content-wrapper").fadeToggle(0);
            $("#btn_global").toggleClass("sites-active sites-inactive");
            if ($("#btn_global").hasClass("sites-active")) {
                setTimeout(() => {
                    const sitesListLinks = document.querySelectorAll(".global-sites a");
                    sitesListLinks[0].focus();
                }, 0);
            }
        }

        function toggleSearch() {
            $("#btn-search").toggleClass("search-active search-inactive");
            $("div.search").toggleClass("search-open search-closed");
            if ($("#btn-search").hasClass("search-active")) {
                setTimeout(() => {
                    const searchMenuFocusableEl = document.querySelectorAll(
                        '#tSearchContainer [data-ada-focusable="true"]'
                    );
                    searchMenuFocusableEl[0].focus();
                }, 100);
            }
        }

        function toggleMainNav() {
            $("#btn-main-nav").toggleClass("activated inactive");
            $("ul.top-nav").toggleClass("open");
            if ($("ul.top-nav").hasClass("open")) {
                setTimeout(() => {
                    const acoountMenuFocusableEl = document.querySelectorAll("ul.top-nav a");
                    acoountMenuFocusableEl[0].focus();
                }, 100);
            }
        }

        function blurCloseSites(event) {
            if ($("#btn_global").hasClass("sites-active")) {
                const currentParentID = event.srcElement.offsetParent ? event.srcElement.offsetParent.id : null;
                let nextFocusParentID = null;
                if (event.relatedTarget) {
                    nextFocusParentID = event.relatedTarget.offsetParent ? event.relatedTarget.offsetParent.id : null;
                }
                if (currentParentID !== nextFocusParentID) {
                    toggleSites();
                }
            }
        }

        function blurCloseSearch(event) {
            if ($("#btn-search").hasClass("search-active")) {
                const currentParentID = event.srcElement.offsetParent ? event.srcElement.offsetParent.id : null;
                let nextFocusParentID = null;
                if (event.relatedTarget) {
                    nextFocusParentID = event.relatedTarget.offsetParent ? event.relatedTarget.offsetParent.id : null;
                }
                if (currentParentID !== nextFocusParentID) {
                    toggleSearch();
                }
            }
        }

        function blurCloseMainNav(event) {
            if ($("ul.top-nav").hasClass("open")) {
                const currentParentRole = event.srcElement.offsetParent ? event.srcElement.offsetParent.role : null;
                let nextFocusParentRole = null;
                if (event.relatedTarget) {
                    nextFocusParentRole = event.relatedTarget.offsetParent
                        ? event.relatedTarget.offsetParent.role
                        : null;
                }
                console.log(event.srcElement.offsetParent, event.relatedTarget.offsetParent);
                if (currentParentRole !== nextFocusParentRole) {
                    toggleMainNav();
                    $("#btn-main-nav").trigger("focus");
                }
            }
        }

        function showHideSites() {
            //if( $('#btn_global').hasClass('sites-active') ){ toggleSites() }
            if ($("#btn-search").hasClass("search-active")) {
                toggleSearch();
            }
            if ($("#btn-main-nav").hasClass("activated")) {
                toggleMainNav();
            }
            toggleSites();
            if ($("#btn_global").hasClass("sites-active")) {
                const sitesListLinks = document.querySelectorAll(".global-sites a");
                sitesListLinks.forEach((el) => {
                    el.addEventListener("blur", blurCloseSites);
                });
            }
        }

        function showHideSearch() {
            if ($("#btn_global").hasClass("sites-active")) {
                toggleSites();
            }
            //if( $('#btn-search').hasClass('search-active') ){ toggleSearch() }
            if ($("#btn-main-nav").hasClass("activated")) {
                toggleMainNav();
            }
            toggleSearch();
            if ($("#btn-search").hasClass("search-active")) {
                const searchMenuFocusableEl = document.querySelectorAll(
                    '#tSearchContainer [data-ada-focusable="true"]'
                );
                searchMenuFocusableEl.forEach((el) => {
                    el.addEventListener("blur", blurCloseSearch);
                });
            }
        }

        function showHideMainNav() {
            if ($("#btn_global").hasClass("sites-active")) {
                toggleSites();
            }
            if ($("#btn-search").hasClass("search-active")) {
                toggleSearch();
            }
            //if ($("#btn-main-nav").hasClass("activated")) { toggleMainNav(); }
            toggleMainNav();
            if ($("#btn-main-nav").hasClass("activated")) {
                const mainNavFocusableElements = document.querySelectorAll("#main-nav a.dropdownLink");
                console.log(mainNavFocusableElements);
                mainNavFocusableElements.forEach((el) => {
                    el.addEventListener("blur", blurCloseMainNav);
                });
            }
        }

        $("#btn_global").on("mousedown", showHideSites);
        $("#btn_global").on("keydown", (event) => {
            if (event.key === "Enter") {
                showHideSites();
            }
        });

        $("#btn-search").on("mousedown", showHideSearch);
        $("#btn-search").on("keydown", (event) => {
            if (event.key === "Enter") {
                showHideSearch();
            }
        });

        $("#btn-main-nav").on("mousedown", showHideMainNav);
        $("#btn-main-nav").on("keydown", (event) => {
            if (event.key === "Enter") {
                showHideMainNav();
            }
        });

        $("html").on("click", function () {
            if ($(".global-sites li ul").not(".mobile .global-sites li ul").is(":visible")) {
                $(".global-sites > li > p").toggleClass("sites-inactive sites-active").next("ul").slideToggle("fast");
            }
        });

        $(".global-sites > li > p").on("click", function (event) {
            event.stopPropagation();
        });
    });

    //Calculate Footer height for parallax effect

    function checkHeight() {
        var footerHeight = $("div.footer-wrap-bottom").height();
        $("div.footer-wrap-top").css("margin-bottom", footerHeight + "px");
    }
    checkHeight();
    $(window).on("resize", checkHeight);

    //Scroll to botton when focus on footer
    $(function () {
        $(".footer-wrap-bottom").on("focusin", function () {
            let currentScrollPosition = $(window).scrollTop();
            let bottomScrollPosition = $(document).height() - $(window).height();
            if (currentScrollPosition < bottomScrollPosition) {
                $("html, body").animate({ scrollTop: bottomScrollPosition}, 0);
            }
        });
    });

    //Product Page Item description collapse and tabs
    $(function () {
        const $tabLinksWrap = $("#tabs > .tab-links");
        const $tabFirstBtn = $tabLinksWrap.find("button").eq(0);

        $("#tabs > div").hide();
        $("#tabs > div:first").show();
        $tabFirstBtn.addClass("active");

        $tabLinksWrap.on("click", "button", function () {
            const $this = $(this);
            const $sibling = $this.siblings();

            $sibling.removeClass("active").attr({
                tabindex: "-1",
                "aria-selected": "false",
            });

            $this.addClass("active").attr({
                tabindex: "0",
                "aria-selected": "true",
            });

            var currentTab = $this.attr("aria-controls");
            $("#tabs > div").hide();
            $(`#${currentTab}`).show();

            return false;
        });
    });

    /* Slide Up Elements */
    $(".anim").addClass("hidden").viewportChecker({
        classToAdd: "visible animation fadeInUp",
        offset: 40,
    });
    /* Fade In Elements */
    $(".anim-fade, .mobile-cta span").addClass("hidden").viewportChecker({
        classToAdd: "visible animation fadeIn",
        offset: 40,
    });

    function carouselCanvas() {
        if ($("body").hasClass("pghome") == true) {
            // Selectors
            var discImg = $(".discovery-item:first-child .discovery-lifestyle img");
            var discImgWidth = $(discImg).width();
            var discImgHeight = $(discImg).height();
            $(".discovery-item .disc-canvas canvas").attr("width", discImgWidth);
            $(".discovery-item .disc-canvas canvas").attr("height", discImgHeight);
            //$(this).html(drawCanvas);
            renderTheCanvas();
            function renderTheCanvas() {
                var discImg = $(".discovery-item:first-child .discovery-lifestyle img");
                var discImgWidth = $(discImg).width();
                var discImgHeight = $(discImg).height();
                var siloImageWidth = $(".discovery-copy").width();
                $(".discovery-wrap, .discovery-copy").css("height", discImgHeight);
                $(".discovery-product p").css("width", siloImageWidth);
            }
            $(window).on("resize", renderTheCanvas);

            //Discoveries Slider
            ("use strict");
            var _this = void 0;

            var sliderItems = document.querySelectorAll(".discovery-item");
            var canvases = document.querySelectorAll('[name="canvas"]');
            var btnNext = document.querySelector(".row-discoveries .disc_arrows-right");
            var btnPrev = document.querySelector(".row-discoveries .disc_arrows-left");
            var images = [
                "images/banners/renaissance-hotels-chess-board.jpg",
                "images/banners/renaissance-hotels-cork-stools.jpg",
                "images/banners/renaissance-hotels-purple-pillow.jpg",
                "images/banners/renaissance-hotels-face-vase.jpg",
            ];
            var scaleValue = "200";
            // Slider
            var Slider = {
                currentItem: 0,
                init: function init() {
                    sliderItems.forEach(function (item) {
                        item.style.visibility = "hidden";
                    });
                    Slider.in(Slider.currentItem);
                },

                in: function _in(index) {
                    var item = sliderItems[index];
                    var texts = item.querySelectorAll(".discovery-copy div:first-child");
                    var products = item.querySelectorAll(".discovery-product");
                    var borderColor = item.querySelectorAll(".border-color");
                    var theCanvases = item.querySelectorAll(".disc-canvas");
                    var timeline = gsap.timeline();
                    gsap.set(item, { autoAlpha: 0, zIndex: 6 });
                    gsap.set(theCanvases, { autoAlpha: 0 });
                    gsap.set(borderColor, { autoAlpha: 0, left: 0, top: 0, bottom: 0, right: 0 });
                    timeline.to(item, 0.5, { duration: 0.5, autoAlpha: 1 });

                    //canvas animation
                    var canvas = canvases[index];
                    var ctx = canvas.getContext("2d");
                    ctx.imageSmoothingEnabled = false;
                    ctx.webkitImageSmoothingEnabled = false;
                    ctx.mozImageSmoothingEnabled = false;
                    var cw = canvas.width;
                    var ch = canvas.height;
                    var img = new Image();
                    var scale = {
                        value: scaleValue,
                    };
                    img.src = images[index];
                    timeline
                        .to(theCanvases, { duration: 0.5, autoAlpha: 1 })
                        .to(
                            scale,
                            {
                                duration: 0.4,
                                /*autoAlpha: 0,*/ value: 1,
                                ease: Linear.easeNone,
                                delay: 0.5,
                                onUpdate: function onUpdate() {
                                    var sw = (cw / scale.value) >> 0;
                                    var sh = (ch / scale.value) >> 0;
                                    ctx.drawImage(img, 0, 0, sw, sh);
                                    ctx.drawImage(canvas, 0, 0, sw, sh, 0, 0, cw, ch);
                                },
                            },
                            "-=1"
                        )
                        .to(borderColor, {
                            duration: 0.5,
                            autoAlpha: 1,
                            left: "-5%",
                            top: "-5%",
                            bottom: "5%",
                            right: "5%",
                        })
                        .from(texts, { duration: 0.5, y: -30, autoAlpha: 0, ease: Power4.easeOut })
                        .to(products, { duration: 1, autoAlpha: 1, right: "0", ease: Power4.easeOut }, "-=.4");
                },

                out: function out(index, nextIndex) {
                    var item = sliderItems[index];
                    // var texts = item.querySelectorAll('.discovery-copy div:first-child');
                    var products = item.querySelectorAll(".discovery-product");
                    var borderColor = item.querySelectorAll(".border-color");
                    var theCanvases = item.querySelectorAll(".disc-canvas");
                    var timeline = gsap.timeline();
                    gsap.set(item, { zIndex: 1 });
                    timeline
                        // .to(texts, {duration:.5, y: -30,autoAlpha: 0,ease: Back.easeIn}, '-0.5')
                        .to(borderColor, {
                            duration: 0.3,
                            ease: Linear.easeNone,
                            left: 0,
                            top: 0,
                            bottom: 0,
                            right: 0,
                            stagger: "-=0.5",
                        })
                        .to(item, { duration: 0.5, autoAlpha: 0 })
                        .to(theCanvases, { duration: 0.5, autoAlpha: 0 })
                        .to(products, { duration: 0.5, autoAlpha: 0, right: "-30vw", ease: Expo.easeOut }, "-=.4")
                        .call(Slider.in, [nextIndex], "-=1")
                        // .set(texts, {clearProps: 'all'})
                        .set(borderColor, { clearProps: "all" })
                        .set(theCanvases, { clearProps: "all" })
                        .set(products, { clearProps: "all" });
                },
                next: function next() {
                    var next = Slider.currentItem !== sliderItems.length - 1 ? Slider.currentItem + 1 : 0;
                    Slider.out(Slider.currentItem, next);
                    Slider.currentItem = next;
                },
                prev: function prev() {
                    var prev = Slider.currentItem > 0 ? Slider.currentItem - 1 : sliderItems.length - 1;
                    Slider.out(Slider.currentItem, prev);
                    Slider.currentItem = prev;
                }, // Events
            };
            btnNext.addEventListener("click", Slider.next);
            btnPrev.addEventListener("click", Slider.prev);
            Slider.init();
        }
    }
    var vieWidth = window.viewportSize.getWidth();
    if (vieWidth > 768 && document.body.classList.contains("pghome")) {
        var imgWrap = document.querySelector("p#chessBoard");
        var chessBoardImg = new Image();
        imgWrap.append(chessBoardImg);
        chessBoardImg.onload = function () {
            carouselCanvas();
        };
        chessBoardImg.alt = "Wobble Chess Set";
        chessBoardImg.src = "images/banners/renaissance-hotels-chess-board.jpg";
    }
    /* Bedding Section Accordion */
    $(".accordion p").hide();
    $(".accordion p:first").show();
    $(".accordion div:first").addClass("active_section");
    $(".accordion button").on("click", function () {
        $(".accordion p").hide();
        var d_activeTab = $(this).attr("rel");
        $("#" + d_activeTab).fadeIn();
        $(".accordion button").removeClass("d_active").parent("div").removeClass("active_section");
        $(this).addClass("d_active").parent("div").addClass("active_section");
    });
    /* Sleep Tips Tips */
    var activeTip = $(".active"),
        homeTip = $(".tip"),
        slideNavPrev = $("#prev"),
        slideNavNext = $("#next"),
        currYPercent = 0;

    function init() {
        if (homeTip.length) {
            gsap.set(homeTip.not(activeTip), { autoAlpha: 0 });
        }
        if (slideNavPrev.length) {
            gsap.set(slideNavPrev, { autoAlpha: 0.2 });
            slideNavPrev[0].ariaHidden = "true";
            slideNavPrev[0].tabIndex = -1;
        }
    }

    init();

    function goToNextSlide(slideOut, slideIn, slideInAll) {
        var tl = gsap.timeline(),
            slideOutContent = slideOut.find(".tip-content"),
            slideInContent = slideIn.find(".tip-content"),
            index = slideIn.index();
        if (slideIn.length !== 0) {
            currYPercent -= 100;

            tl.set(slideIn, {
                autoAlpha: 1,
                onComplete: function () {
                    this.targets()[0].classList.add("active");
                },
            })
                .set(slideOut, {
                    onComplete: function () {
                        this.targets()[0].classList.remove("active");
                    },
                })
                .to(slideOutContent, { duration: 0.65, y: "+=40", ease: "power3.inOut" }, 0)
                .to(slideInAll, { duration: 1, yPercent: currYPercent, ease: "power3.inOut" }, 0)
                .fromTo(slideInContent, { y: "-=40" }, { duration: 0.65, y: 0, ease: "power3.inOut" }, "-=0.7");
        }

        gsap.set(slideNavPrev, { autoAlpha: 1 });
        slideNavPrev[0].ariaHidden = "false";
        slideNavPrev[0].tabIndex = 0;
        if (index === homeTip.length - 1) {
            gsap.to(slideNavNext, { duration: 0.3, autoAlpha: 0, ease: Linear.easeNone });
            slideNavNext[0].ariaHidden = "true";
            slideNavNext[0].tabIndex = -1;
        }
    }

    slideNavNext.on("click", function (e) {
        e.preventDefault();
        var slideOut = $(".tip.active"),
            slideIn = $(".tip.active").next(".tip"),
            slideInAll = $(".tip");

        goToNextSlide(slideOut, slideIn, slideInAll);
    });

    function goToPreviousSlide(slideOut, slideIn, slideInAll) {
        var tl = gsap.timeline(),
            slideOutContent = slideOut.find(".tip-content"),
            slideInContent = slideIn.find(".tip-content"),
            index = slideIn.index();
        if (slideIn.length !== 0) {
            currYPercent += 100;

            tl.set(slideIn, {
                autoAlpha: 1,
                onComplete: function () {
                    this.targets()[0].classList.add("active");
                },
            })
                .set(slideOut, {
                    onComplete: function () {
                        this.targets()[0].classList.remove("active");
                    },
                })
                .to(slideOutContent, { duration: 0.65, y: "-40", ease: "power3.inOut" }, 0)
                .to(slideInAll, { duration: 1, yPercent: currYPercent, ease: "power3.inOut" }, 0)
                .fromTo(slideInContent, { y: "+=40" }, { duration: 0.65, y: 0, ease: "power3.inOut" }, "-=0.7");
        }

        gsap.set(slideNavNext, { autoAlpha: 1 });
        slideNavNext[0].ariaHidden = "false";
        slideNavNext[0].tabIndex = 0;
        if (index === 0) {
            gsap.to(slideNavPrev, { duration: 0.3, autoAlpha: 0.0, ease: Linear.easeNone });
            slideNavPrev[0].ariaHidden = "true";
            slideNavPrev[0].tabIndex = -1;
        }
    }

    slideNavPrev.on("click", function (e) {
        e.preventDefault();
        var slideOut = $(".tip.active"),
            slideIn = $(".tip.active").prev(".tip"),
            slideInAll = $(".tip");

        goToPreviousSlide(slideOut, slideIn, slideInAll);
    });
    /* Ends Tips Slider */

    /* Promo Headers - */
    (function ($) {
        $.fn.flowtype = function (options) {
            var settings = $.extend(
                    {
                        maximum: 9999,
                        minimum: 1,
                        maxFont: 9999,
                        minFont: 1,
                        fontRatio: 35,
                    },
                    options
                ),
                changes = function (el) {
                    var $el = $(el),
                        elw = $el.width(),
                        width =
                            elw > settings.maximum ? settings.maximum : elw < settings.minimum ? settings.minimum : elw,
                        fontBase = width / settings.fontRatio,
                        fontSize =
                            fontBase > settings.maxFont
                                ? settings.maxFont
                                : fontBase < settings.minFont
                                ? settings.minFont
                                : fontBase;
                    $el.css("font-size", fontSize + "px");
                };

            return this.each(function () {
                var that = this;
                $(window).on("resize", function () {
                    changes(that);
                });
                changes(this);
            });
        };
    })(jQuery);

    $("#hdr-banner p, .sweeps_banner").flowtype({
        minimum: 420,
        maximum: 1200,
        minFont: 17,
        maxFont: 45,
        fontRatio: 35,
    });
    $(".promo-wrapper .promo-inner").flowtype({
        minimum: 420,
        maximum: 1200,
        minFont: 16,
        //maxFont   : 45,
        fontRatio: 35,
    });
    /*Detections*/
    var root = document.getElementsByTagName("html")[0];
    if (!document.createElement("svg").getAttributeNS) {
        root.setAttribute("class", "no-svg");
        return;
    }
    /* IE 10 Detection due to checkbox issues*/
    if (Function("/*@cc_on return document.documentMode===10@*/")()) {
        document.documentElement.className += " ie10";
    }

    /*Hover Intent*/
    var $dropdowns = $(".shop-cart, .top-nav > li");
    $dropdowns
        .on("mouseover", function () {
            var $this = $(this);
            if ($this.prop("hoverTimeout")) {
                $this.prop("hoverTimeout", clearTimeout($this.prop("hoverTimeout")));
            }
            $this.prop(
                "hoverIntent",
                setTimeout(function () {
                    $this.addClass("hover");
                }, 50)
            );
        })
        .on("mouseleave", function () {
            var $this = $(this);
            if ($this.prop("hoverIntent")) {
                $this.prop("hoverIntent", clearTimeout($this.prop("hoverIntent")));
            }
            $this.prop(
                "hoverTimeout",
                setTimeout(function () {
                    $this.removeClass("hover");
                }, 50)
            );
        });
});
/*Slide In Animations Viewport Check*/
(function ($) {
    $.fn.viewportChecker = function (useroptions) {
        var options = {
            classToAdd: "visible",
            offset: 100,
            callbackFunction: function (elem) {},
        };
        $.extend(options, useroptions);
        var $elem = this,
            windowHeight = $(window).height();

        this.checkElements = function () {
            // Set some vars to check with
            var viewportTop = Math.max($("html").scrollTop(), $("body").scrollTop(), $(window).scrollTop()),
                viewportBottom = viewportTop + windowHeight;

            $elem.each(function () {
                var $obj = $(this);
                if ($obj.hasClass(options.classToAdd)) {
                    return;
                }
                var elemTop = Math.round($obj.offset().top) + options.offset,
                    elemBottom = elemTop + $obj.height();
                if (elemTop < viewportBottom && elemBottom > viewportTop) {
                    $obj.addClass(options.classToAdd);
                    options.callbackFunction($obj);
                }
            });
        };
        $(window).on("scroll", this.checkElements);
        this.checkElements();
        $(window).on("resize", function (e) {
            windowHeight = e.currentTarget.innerHeight;
        });
    };
})(jQuery);
